import { Component, Input, OnInit } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { Router } from '@angular/router';

@Component({
  selector: 'count-widget',
  templateUrl: './count-widget.component.html',
  styleUrls: ['./count-widget.component.scss'],
  animations: fuseAnimations,
})
export class CountWidgetComponent implements OnInit {

  @Input() title: string;
  @Input() count: number;
  @Input() label: string;
  @Input() extracount: number;
  @Input() extralabel: string;
  @Input() detail: string;
  @Input() color: string;
  @Input() route: string;

  constructor(private router: Router) {
    if (!this.title) {
      this.title = 'Cases';
      this.count = 23;
      this.label = 'TOTAL';
      this.extracount = 4;
      this.extralabel = 'Open';
      this.detail = 'More information to go here...';
      this.color = '#0277bd';
    }
  }

  ngOnInit() {
  }

  click() {
    if (this.route) {
      this.router.navigateByUrl(this.route);
    }
  }

  extraClick($event) {
    $event.stopPropagation();
    // do nothing
  }

}
